import { render, staticRenderFns } from "./Monatsabschluss.vue?vue&type=template&id=2f467efa&"
import script from "./Monatsabschluss.vue?vue&type=script&lang=ts&"
export * from "./Monatsabschluss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports